import { render, staticRenderFns } from "./TermsAndConditionsV2.vue?vue&type=template&id=2af0c438&"
import script from "./TermsAndConditionsV2.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsV2.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsV2.vue?vue&type=style&index=0&id=2af0c438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports